

import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    income: {
        background: 'rgba(69, 179, 157)',
        color: '#142A37',
    },
    expense: {
        background: 'rgba(231, 76, 60)',
        color: '#142A37'
    },

    background: {
        background: '#142A37',
        color: '#fff',
        border: '#142A37'
    },





}));